// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_communication.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannelView
 */
export interface SlackChannelView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: bool active = 4;
     */
    active: boolean;
    /**
     * @generated from protobuf field: string binding_id = 5;
     */
    bindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.MSTeamsChannelView
 */
export interface MSTeamsChannelView {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string channel_name = 2;
     */
    channelName: string;
    /**
     * @generated from protobuf field: bool active = 3;
     */
    active: boolean;
    /**
     * @generated from protobuf field: string team_id = 4;
     */
    teamId: string;
    /**
     * @generated from protobuf field: string external_directory_id = 5;
     */
    externalDirectoryId: string;
    /**
     * @generated from protobuf field: string binding_id = 6;
     */
    bindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelRequest
 */
export interface AccessReviewCommunicationServiceGetChannelRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelResponse
 */
export interface AccessReviewCommunicationServiceGetChannelResponse {
    /**
     * @generated from protobuf oneof: channel_metadata
     */
    channelMetadata: {
        oneofKind: "slackChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelView slack_channel = 100;
         */
        slackChannel: SlackChannelView;
    } | {
        oneofKind: "msTeamsChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.MSTeamsChannelView ms_teams_channel = 101;
         */
        msTeamsChannel: MSTeamsChannelView;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsRequest
 */
export interface AccessReviewCommunicationServiceListChannelsRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsResponse
 */
export interface AccessReviewCommunicationServiceListChannelsResponse {
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelView slack_channel = 1;
     */
    slackChannel?: SlackChannelView;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.MSTeamsChannelView ms_teams_channel = 2;
     */
    msTeamsChannel?: MSTeamsChannelView;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannel
 */
export interface SlackChannel {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2;
     */
    description: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.MSTeamsChannel
 */
export interface MSTeamsChannel {
    /**
     * @generated from protobuf field: string channel_name = 1;
     */
    channelName: string;
    /**
     * @generated from protobuf field: string external_directory_id = 2;
     */
    externalDirectoryId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateRequest
 */
export interface AccessReviewCommunicationServiceCreateRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf oneof: channel_metadata
     */
    channelMetadata: {
        oneofKind: "slackChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannel slack_channel = 100;
         */
        slackChannel: SlackChannel;
    } | {
        oneofKind: "msTeamsChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.MSTeamsChannel ms_teams_channel = 101;
         */
        msTeamsChannel: MSTeamsChannel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateResponse
 */
export interface AccessReviewCommunicationServiceCreateResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateRequest
 */
export interface AccessReviewCommunicationServiceActivateRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string channel_binding_id = 2;
     */
    channelBindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateResponse
 */
export interface AccessReviewCommunicationServiceActivateResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateRequest
 */
export interface AccessReviewCommunicationServiceDeactivateRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string channel_binding_id = 2;
     */
    channelBindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateResponse
 */
export interface AccessReviewCommunicationServiceDeactivateResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameRequest
 */
export interface AccessReviewCommunicationServiceValidateChannelNameRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * @generated from protobuf oneof: channel_metadata
     */
    channelMetadata: {
        oneofKind: "slackChannel";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannel slack_channel = 100;
         */
        slackChannel: SlackChannel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannelValid
 */
export interface SlackChannelValid {
    /**
     * @generated from protobuf field: bool is_slack_validation_reason = 1;
     */
    isSlackValidationReason: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannelNotUnique
 */
export interface SlackChannelNotUnique {
    /**
     * @generated from protobuf field: bool is_slack_validation_reason = 1;
     */
    isSlackValidationReason: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.SlackChannelNameInvalid
 */
export interface SlackChannelNameInvalid {
    /**
     * @generated from protobuf field: bool is_slack_validation_reason = 1;
     */
    isSlackValidationReason: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameResponse
 */
export interface AccessReviewCommunicationServiceValidateChannelNameResponse {
    /**
     * @generated from protobuf oneof: validation_response
     */
    validationResponse: {
        oneofKind: "slackChannelValid";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelValid slack_channel_valid = 100;
         */
        slackChannelValid: SlackChannelValid;
    } | {
        oneofKind: "slackChannelNotUnique";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelNotUnique slack_channel_not_unique = 101;
         */
        slackChannelNotUnique: SlackChannelNotUnique;
    } | {
        oneofKind: "slackChannelNameInvalid";
        /**
         * @generated from protobuf field: c1.api.accessreview.v1.SlackChannelNameInvalid slack_channel_name_invalid = 102;
         */
        slackChannelNameInvalid: SlackChannelNameInvalid;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteRequest
 */
export interface AccessReviewCommunicationServiceDeleteRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1;
     */
    accessReviewId: string;
    /**
     * An AR can notify on multiple channels, specify via the ID which channel to delete
     *
     * @generated from protobuf field: string channel_binding_id = 2;
     */
    channelBindingId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteResponse
 */
export interface AccessReviewCommunicationServiceDeleteResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannelView$Type extends MessageType<SlackChannelView> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannelView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannelView
 */
export const SlackChannelView = new SlackChannelView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeamsChannelView$Type extends MessageType<MSTeamsChannelView> {
    constructor() {
        super("c1.api.accessreview.v1.MSTeamsChannelView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "channel_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "team_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.MSTeamsChannelView
 */
export const MSTeamsChannelView = new MSTeamsChannelView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceGetChannelRequest$Type extends MessageType<AccessReviewCommunicationServiceGetChannelRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelRequest
 */
export const AccessReviewCommunicationServiceGetChannelRequest = new AccessReviewCommunicationServiceGetChannelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceGetChannelResponse$Type extends MessageType<AccessReviewCommunicationServiceGetChannelResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelResponse", [
            { no: 100, name: "slack_channel", kind: "message", oneof: "channelMetadata", T: () => SlackChannelView },
            { no: 101, name: "ms_teams_channel", kind: "message", oneof: "channelMetadata", T: () => MSTeamsChannelView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceGetChannelResponse
 */
export const AccessReviewCommunicationServiceGetChannelResponse = new AccessReviewCommunicationServiceGetChannelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceListChannelsRequest$Type extends MessageType<AccessReviewCommunicationServiceListChannelsRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsRequest
 */
export const AccessReviewCommunicationServiceListChannelsRequest = new AccessReviewCommunicationServiceListChannelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceListChannelsResponse$Type extends MessageType<AccessReviewCommunicationServiceListChannelsResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsResponse", [
            { no: 1, name: "slack_channel", kind: "message", T: () => SlackChannelView },
            { no: 2, name: "ms_teams_channel", kind: "message", T: () => MSTeamsChannelView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceListChannelsResponse
 */
export const AccessReviewCommunicationServiceListChannelsResponse = new AccessReviewCommunicationServiceListChannelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannel$Type extends MessageType<SlackChannel> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannel", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "80", pattern: "^[a-z0-9._-]+$" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "250" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannel
 */
export const SlackChannel = new SlackChannel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MSTeamsChannel$Type extends MessageType<MSTeamsChannel> {
    constructor() {
        super("c1.api.accessreview.v1.MSTeamsChannel", [
            { no: 1, name: "channel_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "50", pattern: "^[a-zA-Z0-9]([a-zA-Z0-9 _.-]*[a-zA-Z0-9 _-])?$" } } } },
            { no: 2, name: "external_directory_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.MSTeamsChannel
 */
export const MSTeamsChannel = new MSTeamsChannel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceCreateRequest$Type extends MessageType<AccessReviewCommunicationServiceCreateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 100, name: "slack_channel", kind: "message", oneof: "channelMetadata", T: () => SlackChannel },
            { no: 101, name: "ms_teams_channel", kind: "message", oneof: "channelMetadata", T: () => MSTeamsChannel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateRequest
 */
export const AccessReviewCommunicationServiceCreateRequest = new AccessReviewCommunicationServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceCreateResponse$Type extends MessageType<AccessReviewCommunicationServiceCreateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceCreateResponse
 */
export const AccessReviewCommunicationServiceCreateResponse = new AccessReviewCommunicationServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceActivateRequest$Type extends MessageType<AccessReviewCommunicationServiceActivateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "channel_binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateRequest
 */
export const AccessReviewCommunicationServiceActivateRequest = new AccessReviewCommunicationServiceActivateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceActivateResponse$Type extends MessageType<AccessReviewCommunicationServiceActivateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceActivateResponse
 */
export const AccessReviewCommunicationServiceActivateResponse = new AccessReviewCommunicationServiceActivateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceDeactivateRequest$Type extends MessageType<AccessReviewCommunicationServiceDeactivateRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "channel_binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateRequest
 */
export const AccessReviewCommunicationServiceDeactivateRequest = new AccessReviewCommunicationServiceDeactivateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceDeactivateResponse$Type extends MessageType<AccessReviewCommunicationServiceDeactivateResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeactivateResponse
 */
export const AccessReviewCommunicationServiceDeactivateResponse = new AccessReviewCommunicationServiceDeactivateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceValidateChannelNameRequest$Type extends MessageType<AccessReviewCommunicationServiceValidateChannelNameRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 100, name: "slack_channel", kind: "message", oneof: "channelMetadata", T: () => SlackChannel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameRequest
 */
export const AccessReviewCommunicationServiceValidateChannelNameRequest = new AccessReviewCommunicationServiceValidateChannelNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannelValid$Type extends MessageType<SlackChannelValid> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannelValid", [
            { no: 1, name: "is_slack_validation_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannelValid
 */
export const SlackChannelValid = new SlackChannelValid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannelNotUnique$Type extends MessageType<SlackChannelNotUnique> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannelNotUnique", [
            { no: 1, name: "is_slack_validation_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannelNotUnique
 */
export const SlackChannelNotUnique = new SlackChannelNotUnique$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackChannelNameInvalid$Type extends MessageType<SlackChannelNameInvalid> {
    constructor() {
        super("c1.api.accessreview.v1.SlackChannelNameInvalid", [
            { no: 1, name: "is_slack_validation_reason", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.SlackChannelNameInvalid
 */
export const SlackChannelNameInvalid = new SlackChannelNameInvalid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceValidateChannelNameResponse$Type extends MessageType<AccessReviewCommunicationServiceValidateChannelNameResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameResponse", [
            { no: 100, name: "slack_channel_valid", kind: "message", oneof: "validationResponse", T: () => SlackChannelValid },
            { no: 101, name: "slack_channel_not_unique", kind: "message", oneof: "validationResponse", T: () => SlackChannelNotUnique },
            { no: 102, name: "slack_channel_name_invalid", kind: "message", oneof: "validationResponse", T: () => SlackChannelNameInvalid }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceValidateChannelNameResponse
 */
export const AccessReviewCommunicationServiceValidateChannelNameResponse = new AccessReviewCommunicationServiceValidateChannelNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceDeleteRequest$Type extends MessageType<AccessReviewCommunicationServiceDeleteRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "channel_binding_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteRequest
 */
export const AccessReviewCommunicationServiceDeleteRequest = new AccessReviewCommunicationServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewCommunicationServiceDeleteResponse$Type extends MessageType<AccessReviewCommunicationServiceDeleteResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewCommunicationServiceDeleteResponse
 */
export const AccessReviewCommunicationServiceDeleteResponse = new AccessReviewCommunicationServiceDeleteResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewCommunicationService
 */
export const AccessReviewCommunicationService = new ServiceType("c1.api.accessreview.v1.AccessReviewCommunicationService", [
    { name: "GetChannel", localName: "getChannel$", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceGetChannelRequest, O: AccessReviewCommunicationServiceGetChannelResponse },
    { name: "ListChannels", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceListChannelsRequest, O: AccessReviewCommunicationServiceListChannelsResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceCreateRequest, O: AccessReviewCommunicationServiceCreateResponse },
    { name: "Activate", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceActivateRequest, O: AccessReviewCommunicationServiceActivateResponse },
    { name: "Deactivate", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceDeactivateRequest, O: AccessReviewCommunicationServiceDeactivateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceDeleteRequest, O: AccessReviewCommunicationServiceDeleteResponse },
    { name: "ValidateChannelName", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewCommunicationServiceValidateChannelNameRequest, O: AccessReviewCommunicationServiceValidateChannelNameResponse }
]);
